import { createSlice } from '@reduxjs/toolkit';
import { personnelApi } from '@store/rtk/personnel';
import { TableData } from '@uikit/Tables/types';
import { selectItemType } from '@src/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

export type personnelItemType = {
  allowed: boolean;
  api: string;
  contractorId: number;
  dob: string;
  effectiveDate: string;
  expirationDate: string;
  firstName: string;
  id: number;
  identification: string;
  lastName: string;
  middleName: string;
  ssn: string;
  status: selectItemType;
  type: selectItemType;
};

type PersonnelDataType = {
  personnelData: {
    content: Array<personnelItemType>;
    page: number;
    size: number;
  };
  personnelIdentificationTableData: TableData;
  personnelCertificationTableData: TableData;
  personnelScreeningTableData: TableData;
  personnelPermitTableData: TableData;
  personnelServiceDatesTableData: TableData;
};

const {
  personnelIdentificationColumns,
  personnelCertificationColumns,
  personnelScreeningColumns,
  personnelPermitColumns,
  personnelServiceDatesColumns,
} = TABLE_COLUMNS;

const initialState: PersonnelDataType = {
  personnelData: {
    content: [],
    page: 0,
    size: 10,
  },
  personnelIdentificationTableData: {
    columns: personnelIdentificationColumns,
    rows: [],
  },
  personnelCertificationTableData: {
    columns: personnelCertificationColumns,
    rows: [],
  },
  personnelScreeningTableData: {
    columns: personnelScreeningColumns,
    rows: [],
  },
  personnelPermitTableData: {
    columns: personnelPermitColumns,
    rows: [],
  },
  personnelServiceDatesTableData: {
    columns: personnelServiceDatesColumns,
    rows: [],
  },
};

export const personnelSlice = createSlice({
  name: 'personnel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        personnelApi.endpoints.getPersonnelData.matchFulfilled,
        (state, { payload }) => {
          state.personnelData = payload;
        }
      )
      .addMatcher(
        personnelApi.endpoints.getPersonnelIdentificationTableData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelIdentificationTableData = {
            ...state.personnelIdentificationTableData,
            rows: payload,
          };
        }
      )
      .addMatcher(
        personnelApi.endpoints.getPersonnelCertificationTableData
          .matchFulfilled,
        (state, { payload }) => {
          state.personnelCertificationTableData = {
            ...state.personnelCertificationTableData,
            rows: payload,
          };
        }
      )
      .addMatcher(
        personnelApi.endpoints.getPersonnelScreeningTableData.matchFulfilled,
        (state, { payload }) => {
          state.personnelScreeningTableData = {
            ...state.personnelScreeningTableData,
            rows: payload,
          };
        }
      )
      .addMatcher(
        personnelApi.endpoints.getPersonnelPermitTableData.matchFulfilled,
        (state, { payload }) => {
          state.personnelPermitTableData = {
            ...state.personnelPermitTableData,
            rows: payload,
          };
        }
      )
      .addMatcher(
        personnelApi.endpoints.getPersonnelServiceDateTableData.matchFulfilled,
        (state, { payload }) => {
          state.personnelServiceDatesTableData = {
            ...state.personnelServiceDatesTableData,
            rows: payload,
          };
        }
      );
  },
});

export const selectPersonnel = (state: { personnel: PersonnelDataType }) =>
  state.personnel;
export const personnelReducer = personnelSlice.reducer;
